export const SET_SERVICES = 'SET_SERVICES'
export const RESET_SERVICES = 'RESET_SERVICES'
export const SET_ALL_SERVICES = 'SET_ALL_SERVICES'
export const RESET_ALL_SERVICES = 'RESET_ALL_SERVICES'
